import { Modal } from '@/components/common/dialog';
import { ModalButton } from '@/components/common/modal-button';
import { useTranslation } from 'react-i18next';

interface ZoomDialogProps {
    isOpen: boolean;
    onClose: (isCountdownClose?: boolean) => void;
    onConfirm: () => void;
}

export function ZoomDialog({ isOpen, onClose, onConfirm }: ZoomDialogProps) {
    const { t } = useTranslation();
    const modalId = 'zoom-dialog';

    return (
        <Modal modalIdInit={modalId} isOpen={isOpen} onClose={onClose} className="tts-modal max-w-[calc(680*var(--vw-unit))]" closeRegionOrder={4} closeTabIndex={4}>
            <div className="flex h-full flex-col">
                <header className="text-text-main01 px-[calc(56*var(--vh-unit))] pt-[calc(56*var(--vh-unit))] pb-[calc(8*var(--vh-unit))] text-[calc(58*var(--vh-unit))] leading-normal font-bold tracking-[calc(-1.276*var(--vh-unit))]">
                    <h1 data-modal-region tabIndex={1} aria-label={t('zoom.title')} data-interactive className="focus-border text-center font-bold">
                        {t('zoom.title')}
                    </h1>
                </header>
                <main className="px-[calc(48*var(--vw-unit))] py-[calc(40*var(--vh-unit))]">
                    <div>
                        <p
                            tabIndex={2}
                            data-modal-region
                            data-modal-region-order={2}
                            aria-label={t('zoom.ariaDescription')}
                            data-interactive
                            className="text-text-main01 focus-border text-center text-[calc(40*var(--vh-unit))] leading-[calc(50*var(--vh-unit))] font-medium tracking-[calc(-0.24*var(--vh-unit))]"
                            dangerouslySetInnerHTML={{ __html: t('zoom.description') }}
                        ></p>
                    </div>
                </main>
                <footer className="flex justify-center px-[calc(56*var(--vh-unit))] pt-[calc(24*var(--vh-unit))] pb-[calc(52*var(--vh-unit))]">
                    <ModalButton role="button" variant="primary" aria-label={t('zoom.text.confirmButton')} onClick={onConfirm} data-interactive type="button" 
                            data-modal-region
                            data-modal-region-order={3} tabIndex={3}>
                        {t('zoom.text.confirmButton')}
                    </ModalButton>
                </footer>
            </div>
        </Modal>
    );
}
